import { useMutation, useQueryClient } from "@tanstack/react-query"
import { classes } from '@shared/api/services'

export const useAttachReceipt = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ id, data }) => classes.attachAppointmentReceipt({ id, data }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['history'] })
			queryClient.invalidateQueries({ queryKey: ['appointments'] })
		},
	})
}
